export default "__VITE_ASSET__BqEZV25i__"